import { render, staticRenderFns } from "./commodity_category_filter.vue?vue&type=template&id=b1e08024&"
import script from "./commodity_category_filter.vue?vue&type=script&lang=js&"
export * from "./commodity_category_filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports